// 角色的下拉框
// 全局变量事件类型数据
// 代理账号:zhang1 从: ，企业账号:zhang01， 回收100Q币操作人账号 zhang1：
// 代理账号:zhang1划分: 100币，企业账号:zhang01，操作人账号 zhang1：
// 操作前余额


let beforeBalanceDetail = "操作前 @:qbLog.dict.originRole: 余额 【@:qbLog.dict.beforeBalanceOrigin 】币, @:qbLog.dict.targetRole:【@:qbLog.dict.beforeBalanceTarget】币";

let afterBalanceDetail  =  "操作后 @:qbLog.dict.originRole: 余额 【 @:qbLog.dict.afterBalanceOrigin 】币，@:qbLog.dict.targetRole:【@:qbLog.dict.afterBalanceTarget】币 ";

let opearBalanceDetail = "操作前 余额 【{oldOriginBalance}】币 ,操作后余额 【{originBalance}】币";

let beforeTime = `启用时间 【{originalExpireDate}】 到期时间【{oldExpireDate}】`;

let afterTime = `启用时间 【{originalExpireDate}】 到期时间【{expireDate}】`;


let opearTermDetati = beforeBalanceDetail +beforeTime +"\n"  +afterBalanceDetail + afterTime;

let opearUserDetati = beforeBalanceDetail  +"\n"  +afterBalanceDetail ;




let logEventType = {
  1: {
    label: "划分",
    code: 1,
    logInfo: " 从@:qbLog.dict.originRole:【{originAccount}】 划分【{qb}】币 到 @:qbLog.dict.targetRole 账号:【{targetAccount}】 , 操作人账号:【{operatorAccount}】,"+ opearUserDetati,
  },
  2: {
    label: "回收",
    code: 2,
    logInfo: "从@:qbLog.dict.targetRole:【{targetAccount}】 划分【{qb}】币 到 @:qbLog.dict.originRole 账号:【{originAccount}】 , 操作人账号:【{operatorAccount}】,"+opearUserDetati,
  },
  3: {
    label: "终端划分",
    code: 3,
    logInfo: "从@:qbLog.dict.originRole:【{originAccount}】 划分【{qb}】币 到 @:qbLog.dict.targetRole 账号:【{targetAccount}】 , 操作人账号:【{operatorAccount}】,"+opearTermDetati,
  },

  4: {
    label: "终端回收",
    code: 4,
    logInfo: "从@:qbLog.dict.targetRole:【{targetAccount}】 划分【{qb}】币 到 @:qbLog.dict.originRole 账号:{originAccount} , 操作人账号:【{operatorAccount}】,"+opearTermDetati,
  },

  5: {
    label: "账号移入",
    code: 5,
    logInfo: "操作人账号:{operatorAccount} 将 @:qbLog.dict.targetRole 账号:{targetAccount} 和 '{qb}'Q币  移入到@:qbLog.dict.originRole 账号:{originAccount} "
  },
  6: {
    label: "账号移出",
    code: 6,
    logInfo: "操作人账号:{operatorAccount} 将 @:qbLog.dict.targetRole 账号:{targetAccount} 和 '{qb}'Q币 从@:qbLog.dict.originRole 账号:{originAccount}  移出 "
  },
  7: {
    label: "充值",
    code: 7,
    logInfo: "操作人账号:{operatorAccount} 给 @:qbLog.dict.targetRole 账号:{targetAccount} 充值 '{qb}'Q币 "+opearBalanceDetail
  },

  9: {
    label: "购买订单",
    code: 9,
    logInfo: "操作人账号:{operatorAccount} 给  账号:{targetAccount} 购买订单，支付人：{originAccount}，支付'{qb}'Q币。"+ opearBalanceDetail

  }
};

//事件下拉框
let option = [
  logEventType[1],
  logEventType[2],
  logEventType[3],
  logEventType[4],

  logEventType[5],
  logEventType[6],
  logEventType[7],
  logEventType[9],

];

/**
 * 代理商   1==总代 ,  代理==2, 3=子代理 , 4==企业  ,5== 总代代理管理 ,6==总代子查询 , 7 ==普通用户 ,8==（代理）子查询 ,9==(代理) 企业管理，
 * 10==子代理子查询 ，，11== 子代理企业管理  ,,12=企业的子查询  ，，13==企业的用户管理 ,, 14== 二级企业
 * 15 == 二级企业的子查询  16=会计  17==子代理新增的企业
 */



const qbLog = {
  //数据字典
  dict: {
    originRole: "{originRole,select,1{总代理} 2{代理} 3{子代理} 4{企业}  5{总代子管理} 6{总代子查询} 7{终端} 8{代理子查询} 9{代理子管理} " +
    "10{子代理子查询} 11{子代理子管理} 12{企业子查询} 13{企业子管理} other{无角色信息}}",
    targetRole: "{targetRole,select,1{总代理} 2{代理} 3{子代理} 4{企业}  5{总代子管理} 6{总代子查询} 7{终端} 8{代理子查询} 9{代理子管理} " +
    "10{子代理子查询} 11{子代理子管理} 12{企业子查询} 13{企业子管理} other{无角色信息}}",
    beforeBalanceOrigin:'beforeBalanceOrigin',
    beforeBalanceTarget:`beforeBalanceTarget`,
    afterBalanceOrigin:`afterBalanceOrigin`,
    afterBalanceTarget:`afterBalanceTarget`,
  },
  option,
  logEventType
};



export default qbLog;



// WEBPACK FOOTER //
// ./src/api/lang/modules/oplog/qbLog_en.js